import React from "react";
import { MDBRow, MDBCol } from "mdbreact";

import { GGgetMode } from "../../services/gglocalstorage";
import "./CardCoordenador.css";

/**
 * Card do coordenador de curso.
 */
export default function CardCoordenador({ coordenadorSelecionado }) {
	const nomeCoordenador =
		coordenadorSelecionado?.Informacoes?.NomeCoordenador?.Value;

	const informacoesContato =
		coordenadorSelecionado?.Informacoes?.InformacoesContato?.Value;

	const temImagem =
		coordenadorSelecionado?.Informacoes?.ImagemCoordenador?.HasValue;

	const urlImagem =
		coordenadorSelecionado?.Informacoes?.ImagemCoordenador?.Media?.PublicUrl;

	// Modificação para alterar o Ramal de Medicina Veterinária
	const medicinavet =
		nomeCoordenador === "Prof. Dr. Gabriel Ribas Pereira"
			? "<p>E-mail: medicinaveterinaria@feevale.br<br>Telefone: (51) 3586 8800, ramal 6471</p>"
			: informacoesContato;

	return (
		<div className="cardCoordenador">
			<MDBRow className="cardCoordenador-row">
				{temImagem && !GGgetMode() && (
					<MDBCol
						xs="12"
						sm="4"
						md="4"
						className="cardCoordenador-fotoCol"
					>
						<img
							className="cardCoordenador-foto"
							src={urlImagem}
							alt={nomeCoordenador || "Coordenador do curso"}
						/>
					</MDBCol>
				)}

				<MDBCol
					xs="12"
					sm={temImagem && !GGgetMode() ? "8" : "12"}
					md={temImagem && !GGgetMode() ? "8" : "12"}
					className="cardCoordenador-conteudoCol"
				>
					<div className="coordenacao-curso">
						<h4>Coordenação do curso</h4>

						{nomeCoordenador && (
							<h6 className="cardCoordenador-nome">
								{nomeCoordenador}
							</h6>
						)}

						{medicinavet && (
							<div
								className="cardCoordenador-contato"
								dangerouslySetInnerHTML={{ __html: medicinavet }}
							/>
						)}
					</div>
				</MDBCol>
			</MDBRow>
		</div>
	);
}
